module.exports = __webpack_public_path__ + "fonts/AvenirNextCondensed-Bold.89338299.woff";